import React from "react";
import { graphql } from "gatsby";
import { SanitySlice, SEO } from "@ottomotors/ottomotors.com/components";
import { AnchorLinks } from "@ottomotors/ottomotors.com/slices";
import { IOttoMotorsPressRelease } from "@ottomotors/ottomotors-sanity";

import * as styles from "./styles.module.scss";

interface IProps {
  data: {
    sanityOttomotorsPressRelease: IOttoMotorsPressRelease;
  };
}

// if publishedDate is before today bail out
// if we add published time (what hour do you want this to go live?)

// add publishTime
// establish timezone
// for every PR we'd need to compare the time to now
// if now is before the publish time and you're on a press release page redirect
// on press release index and search results we'd need to hide or ignore press releases that have

// useMemo to store current time when mounted

// what timezone
// SEO: should we make it indexable before its live? we can possibly gain page rank stuff ahead of time.
// only hide in grid?
// can preview

const PressRelease = ({ data: staticData }: IProps) => {
  const { sanityOttomotorsPressRelease } = staticData;
  const { pagebuilder, title, publishedDate, hasAnchorLinks, sideAnchorLinks, seo } =
    sanityOttomotorsPressRelease || {};

  if (!pagebuilder?.slices?.[0]) {
    return null;
  }

  const pageMetadata = {
    heading: seo?.title || title,
    description: seo?.description,
    publishedDate: publishedDate,
  };

  return (
    <div className={styles.container}>
      {hasAnchorLinks && <AnchorLinks data={{ slices: pagebuilder.slices, side: sideAnchorLinks }} />}

      {pagebuilder.slices.map((slice: any) => (
        <div key={slice._key}>
          <SanitySlice
            key={slice._key}
            data={slice}
            pageMetadata={pageMetadata}
          />
        </div>
      ))}
    </div>
  );
};

export default PressRelease;

export const query = graphql`
  query PressRelease($id: String!) {
    sanityOttomotorsPressRelease(id: { eq: $id }) {
      title
      slug {
        current
      }
      hasAnchorLinks
      sideAnchorLinks

      publishedDate

      pagebuilder {
        ...OttomotorsPagebuilderFragment
      }

      seo {
        ...SeoFragment
      }

      _type
    }
  }
`;

export const Head = ({ data: { sanityOttomotorsPressRelease } }: IProps) => {
  const {
    slug: { current: slug },
    title,
    seo,
    _type,
  } = sanityOttomotorsPressRelease;

  const pathname = slug === `/` ? `/` : `/${slug}/`;

  const seoTitle = seo?.title || title;

  return (
    <SEO
      pageTitle={seoTitle}
      pageType={_type}
      pathname={pathname}
      description={seo?.description}
      keywords={seo?.keywords}
      openGraphImageUrl={seo?.image?.asset?.url}
      noIndex={seo?.noIndex}
    />
  );
};
